import { render } from "./VXPass.vue?vue&type=template&id=5c3442f4&scoped=true"
import script from "./VXPass.vue?vue&type=script&lang=js"
export * from "./VXPass.vue?vue&type=script&lang=js"

import "./VXPass.vue?vue&type=style&index=0&id=5c3442f4&scoped=true&lang=css"

import exportComponent from "/tmp/build_1ea34a31/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c3442f4"]])

export default __exports__